export const TRANSLATION_KEYS = {
    Heading: "settingPage.customViewPage.deleteDialog.heading",
    SecondaryHeading: "settingPage.customViewPage.deleteDialog.secondaryHeading",
    ConfirmText: "common.deleteText",
    DismissText: "common.dismissText"
};